var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8278 12.7391C16.7806 12.8533 16.7005 12.9509 16.5977 13.0196C16.4949 13.0883 16.3741 13.125 16.2505 13.125H3.75049C3.62681 13.1251 3.50587 13.0885 3.403 13.0198C3.30013 12.9512 3.21995 12.8535 3.1726 12.7392C3.12526 12.625 3.11288 12.4992 3.13704 12.3779C3.16119 12.2566 3.2208 12.1452 3.3083 12.0578L9.5583 5.80782C9.61635 5.74971 9.68528 5.70361 9.76115 5.67215C9.83703 5.6407 9.91836 5.62451 10.0005 5.62451C10.0826 5.62451 10.164 5.6407 10.2398 5.67215C10.3157 5.70361 10.3846 5.74971 10.4427 5.80782L16.6927 12.0578C16.7801 12.1453 16.8395 12.2567 16.8636 12.3779C16.8877 12.4992 16.8752 12.6249 16.8278 12.7391Z",
    fill: "#1E1E1E",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.146cf371f650eb715c6d3ae948ead94f.svg";
export { ForwardRef as ReactComponent };